import { render, staticRenderFns } from "./EliminarProveedor.vue?vue&type=template&id=5490e357"
import script from "./EliminarProveedor.vue?vue&type=script&lang=js"
export * from "./EliminarProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports